import Modal from "metabase/common/components/Modal";
import Triggerable from "metabase/common/components/Triggerable";

/**
 * @deprecated use Modal + useState
 */
export default Triggerable(Modal);
